import React, {useRef, useState} from 'react';
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {AuthorizedContextProvider} from "../context/AuthorizedContext";
import {Helmet} from "react-helmet";
import AuthenticatedUserLayout from "../layouts/AuthenticatedUserLayout";
import CloseBottomBar from "../components/core/CloseBottomBar";
import queryString from 'query-string';
import {useNavigate, useLocation} from "react-router-dom";
import {Button} from "@material-ui/core";
import {EVENT_UPDATE_PAGE_PATH} from "../layouts/navigation/Navigator";
import {IShipment} from "../components/core/shipments/ShipmentList";
import EventCreatePageComponents from "../components/page-event-create/EventCreatePageComponents";
import {FormikValues} from "formik";
import Loader from "../components/core/Loader";
import { normalizeToString } from '../utils/QueryParamNormalizerUtils';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
            marginBottom: 80
        },
        loader: {
            "& .MuiCircularProgress-root": {
                maxWidth: 30,
                maxHeight: 30,
                margin: 0
            }
        }
    })
);

const EventCreatePage = () => {

    const classes = useStyles();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const {redirect} = queryString.parse(location.search);

    const formRef = useRef<FormikValues>();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [shipment, setShipment] = React.useState<IShipment | undefined>(undefined);
    const shipmentTitle = shipment ? ` - ${shipment.spotID} (${t("core.modality." + shipment.modality)})` : "";


    return (
        <AuthorizedContextProvider>

            <Helmet>
                <title>{t("page.title.event-create-update")}</title>
                <meta name="description" content={t("page.title.event-create-update")}/>
            </Helmet>

            <div className={classes.root}>
                <AuthenticatedUserLayout pageTitle={t("page.title.event-create-update") + shipmentTitle}>

                    <EventCreatePageComponents setShipment={setShipment} formRef={formRef}/>

                </AuthenticatedUserLayout>
            </div>

            <CloseBottomBar executeClose={() => navigate(normalizeToString(redirect) ?? EVENT_UPDATE_PAGE_PATH)}>
                {isSubmitting ? <div className={classes.loader}><Loader/></div> :
                    <Button variant="contained" color="primary" size="small" onClick={() => {
                        setIsSubmitting(true);
                        formRef.current?.submitForm().then(() => setIsSubmitting(false));
                    }}>
                        {t("buttons.add-event")}
                    </Button>}
            </CloseBottomBar>


        </AuthorizedContextProvider>
    );
};

export default EventCreatePage;